/* eslint-disable  @typescript-eslint/no-unused-vars */
/* eslint-disable  @typescript-eslint/no-useless-constructor */
/* eslint-disable  @typescript-eslint/no-redundant-type-constituents */
/* eslint-disable @typescript-eslint/no-extraneous-class */
/* eslint-disable @typescript-eslint/no-empty-object-type */
import { z } from 'zod';
import { validate } from '../../error/validate';
import { enumSchema, domainWsIntervalTypeSchema, type DomainWsIntervalType, localDatetimeSchema, type DomainWsVariantObject, type DomainWsVariantAvailability, type DomainJsonObject, type DomainWspdclasttrans, type DomainWscommitid, } from '../../schema';
import { type WebResponseResult, ValidationError } from '@pdcfrontendui/staffplan';
import { WebRequest } from './WebRequest';
import {
  WebTypeViewField,
  WebField,
  WebRecord,
  WebList,
  WebElement,
  LogonSettings,
  WebSortConfig,
  WebFieldConfig,
  WebListConfig,
  WebRecordType,
  WsRefPerson,
  WsRefOrgunit,
  WsRefOrgunitByInfo,
  WsRefShiftCounter,
  WsRefShifttype,
  WsRefTaskDef,
  WsRefTask,
  WsRefAccount,
  WsRefProject,
  WsRefDimensionItem,
  PersonInfo,
  PersonGroupMember,
  globalSettingsSchema,
  webElementSchema,
  webFieldConfigSchema,
  webFieldSchema,
  webListConfigSchema,
  webListSchema,
  webRecordSchema,
  webRecordTypeSchema,
  webSortConfigSchema,
  webTypeViewFieldSchema,
  wsRefAccountByNameSchema,
  wsRefAccountSchema,
  wsRefDimensionItemByNameSchema,
  wsRefDimensionItemSchema,
  wsRefOrgunitByInfoSchema,
  wsRefOrgunitSchema,
  wsRefPersonByAuxSchema,
  wsRefPersonByNameSchema,
  wsRefPersonBySalaryIdSchema,
  wsRefPersonSchema,
  wsRefProjectByNameSchema,
  wsRefProjectSchema,
  wsRefShiftCounterSchema,
  wsRefShiftDefByExternalIdSchema,
  wsRefShiftDefByIdSchema,
  wsRefShiftDefByNameSchema,
  wsRefShiftDefSchema,
  wsRefShiftTypeByExternalIdSchema,
  wsRefShiftTypeByNameSchema,
  wsRefShifttypeSchema,
  wsRefTaskByExternalIdSchema,
  wsRefTaskByNameSchema,
  wsRefTaskDefByExternalIdSchema,
  wsRefTaskDefByNameSchema,
  wsRefTaskDefSchema,
  wsRefTaskSchema,
  personInfoSchema,
  personGroupMemberSchema,
  globalSettingsJsonSchema,
  webElementJsonSchema,
  webFieldConfigJsonSchema,
  webFieldJsonSchema,
  webListConfigJsonSchema,
  webListJsonSchema,
  webRecordJsonSchema,
  webRecordTypeJsonSchema,
  webSortConfigJsonSchema,
  webTypeViewFieldJsonSchema,
  wsRefAccountByNameJsonSchema,
  wsRefAccountJsonSchema,
  wsRefDimensionItemByNameJsonSchema,
  wsRefDimensionItemJsonSchema,
  wsRefOrgunitByInfoJsonSchema,
  wsRefOrgunitJsonSchema,
  wsRefPersonByAuxJsonSchema,
  wsRefPersonByNameJsonSchema,
  wsRefPersonBySalaryIdJsonSchema,
  wsRefPersonJsonSchema,
  wsRefProjectByNameJsonSchema,
  wsRefProjectJsonSchema,
  wsRefShiftCounterJsonSchema,
  wsRefShiftDefByExternalIdJsonSchema,
  wsRefShiftDefByIdJsonSchema,
  wsRefShiftDefByNameJsonSchema,
  wsRefShiftDefJsonSchema,
  wsRefShiftTypeByExternalIdJsonSchema,
  wsRefShiftTypeByNameJsonSchema,
  wsRefShifttypeJsonSchema,
  wsRefTaskByExternalIdJsonSchema,
  wsRefTaskByNameJsonSchema,
  wsRefTaskDefByExternalIdJsonSchema,
  wsRefTaskDefByNameJsonSchema,
  wsRefTaskDefJsonSchema,
  wsRefTaskJsonSchema,
  personInfoJsonSchema,
  personGroupMemberJsonSchema,
} from './Common_api';
import { PlanEnum, AttendanceClockInOutEnum, TimeAttendanceDeviationEnum, WsAttendanceQueryTypeEnum, TimeAttendanceRefTypeEnum, WsTimeRegEventTypeEnum, UserLoginTypeEnum, StaffUserTypeEnum, ApplicationEnum, PlanSchema, AttendanceClockInOutSchema, TimeAttendanceDeviationSchema, WsAttendanceQueryTypeSchema, TimeAttendanceRefTypeSchema, WsTimeRegEventTypeSchema, UserLoginTypeSchema, StaffUserTypeSchema, ApplicationSchema, PlanJsonSchema, AttendanceClockInOutJsonSchema, TimeAttendanceDeviationJsonSchema, WsAttendanceQueryTypeJsonSchema, TimeAttendanceRefTypeJsonSchema, WsTimeRegEventTypeJsonSchema, UserLoginTypeJsonSchema, StaffUserTypeJsonSchema, ApplicationJsonSchema } from './enumLib_api';
export const userKeySchema = z.object({
	UserId: z.int(),
	UserType: UserLoginTypeSchema
});

export const userKeyJsonSchema = z.object({
	UserId: z.int(),
	UserType: UserLoginTypeJsonSchema
}).describe("Represents a user (employee or planner)");

/**
	Represents a user (employee or planner)
	Responsible: AGRU, Updated: 20230509
*/
export class UserKey {
	constructor(
		public UserId: number,
		public UserType: UserLoginTypeEnum,
	) {}
}

export const logonResponseSchema = z.object({
	token: z.string(),
	name: z.string(),
	userKey: z.lazy(() => userKeySchema),
	staffUserType: StaffUserTypeSchema.optional().nullable().default(null)
});

export const logonResponseJsonSchema = z.object({
	token: z.string(),
	name: z.string(),
	userKey: z.lazy(() => userKeyJsonSchema),
	staffUserType: StaffUserTypeJsonSchema.optional().nullable().default(null)
}).describe("Representation of login response");

/**
	Representation of login response
	Responsible: AGRU, Updated: 20230509
*/
export class LogonResponse {
	constructor(
		public token: string,
		public name: string,
		public userKey: UserKey,
		public staffUserType: StaffUserTypeEnum | null = null,
	) {}
}

export const impersonateResponseSchema = z.object({
	token: z.string(),
	name: z.string(),
	username: z.string(),
	userKey: z.lazy(() => userKeySchema),
	institutionId: z.string().optional().nullable().default(null),
	institutionLabel: z.string().optional().nullable().default(null),
	salaryid: z.string().optional().nullable().default(null)
});

export const impersonateResponseJsonSchema = z.object({
	token: z.string(),
	name: z.string(),
	username: z.string(),
	userKey: z.lazy(() => userKeyJsonSchema),
	institutionId: z.string().optional().nullable().default(null),
	institutionLabel: z.string().optional().nullable().default(null),
	salaryid: z.string().optional().nullable().default(null)
}).describe("Response from impersonateEmpuser");

/**
	Response from impersonateEmpuser
	Responsible: AGRU, Updated: 20250917
*/
export class ImpersonateResponse {
	constructor(
		public token: string,
		public name: string,
		public username: string,
		public userKey: UserKey,
		public institutionId: string | null = null,
		public institutionLabel: string | null = null,
		public salaryid: string | null = null,
	) {}
}

/**
	Login for user with given username and password plus a deviceid used to send push messages back to that user Returns a token to be used in future Authorization headers if login succeeds
	Responsible: JMQ, Updated: 20170907
*/
export class Login extends WebRequest<LogonResponse> {
	public readonly webService = "login";
	public readonly method = "Login";
	public readonly noUserValidation = true;
	public readonly noAuditAction = false;

	constructor(
		public username: string,
		public password: string,
		public deviceid: string,
		public application: ApplicationEnum,
	) {
		super();
	}

	public static readonly create = (x: {username: string, password: string, deviceid: string, application: ApplicationEnum}): Login => {
        return new Login(x.username, x.password, x.deviceid, x.application);
          }
	public static readonly returnSchema = z.lazy(() => logonResponseSchema);
	public resultFromJSON(json: WebResponseResult<LogonResponse>): LogonResponse {
		return validate(Login.returnSchema, json) as unknown as LogonResponse;
	}
}

/**
	Logout the current user (specified in the JWT) and end the pdcsession such that the JWT cannot be renewed
	Responsible: JMQ, Updated: 20170907
*/
export class Logout extends WebRequest<boolean> {
	public readonly webService = "login";
	public readonly method = "Logout";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
	) {
		super();
	}

	public static readonly create = (x: {}): Logout => {
        return new Logout();
          }
	public static readonly returnSchema = z.boolean();
	public resultFromJSON(json: WebResponseResult<boolean>): boolean {
		return validate(Logout.returnSchema, json) as unknown as boolean;
	}
}

/**
	StaffUser logon with frontend hashed password The field LogonResponse.staffUserType always returns the usertype
	Responsible: MMI, Updated: 20180608
*/
export class Login_02 extends WebRequest<LogonResponse> {
	public readonly webService = "login";
	public readonly method = "Login_02";
	public readonly noUserValidation = true;
	public readonly noAuditAction = false;

	constructor(
		public username: string,
		public passwordHash: string,
		public application: ApplicationEnum,
	) {
		super();
	}

	public static readonly create = (x: {username: string, passwordHash: string, application: ApplicationEnum}): Login_02 => {
        return new Login_02(x.username, x.passwordHash, x.application);
          }
	public static readonly returnSchema = z.lazy(() => logonResponseSchema);
	public resultFromJSON(json: WebResponseResult<LogonResponse>): LogonResponse {
		return validate(Login_02.returnSchema, json) as unknown as LogonResponse;
	}
}

/**
	Make a frontend hashed password
	Responsible: JMQ, Updated: 20190514
*/
export class MakeFrontendHashedPassword extends WebRequest<string> {
	public readonly webService = "login";
	public readonly method = "MakeFrontendHashedPassword";
	public readonly noUserValidation = true;
	public readonly noAuditAction = false;

	constructor(
		public username: string,
		public password: string,
	) {
		super();
	}

	public static readonly create = (x: {username: string, password: string}): MakeFrontendHashedPassword => {
        return new MakeFrontendHashedPassword(x.username, x.password);
          }
	public static readonly returnSchema = z.string();
	public resultFromJSON(json: WebResponseResult<string>): string {
		return validate(MakeFrontendHashedPassword.returnSchema, json) as unknown as string;
	}
}

/**
	Logon with OpenId Returns token from openid
	Responsible: JBL, Updated: 20211027
*/
export class LoginOpenId_employee extends WebRequest<LogonResponse> {
	public readonly webService = "login";
	public readonly method = "LoginOpenId_employee";
	public readonly noUserValidation = true;
	public readonly noAuditAction = false;

	constructor(
		public accessCode: string,
		public redirectURI: string,
	) {
		super();
	}

	public static readonly create = (x: {accessCode: string, redirectURI: string}): LoginOpenId_employee => {
        return new LoginOpenId_employee(x.accessCode, x.redirectURI);
          }
	public static readonly returnSchema = z.lazy(() => logonResponseSchema);
	public resultFromJSON(json: WebResponseResult<LogonResponse>): LogonResponse {
		return validate(LoginOpenId_employee.returnSchema, json) as unknown as LogonResponse;
	}
}

/**
	Logon with OpenId Returns token from openid
	Responsible: JBL, Updated: 20211027
*/
export class LoginOpenId_planner extends WebRequest<LogonResponse> {
	public readonly webService = "login";
	public readonly method = "LoginOpenId_planner";
	public readonly noUserValidation = true;
	public readonly noAuditAction = false;

	constructor(
		public accessCode: string,
		public redirectURI: string,
	) {
		super();
	}

	public static readonly create = (x: {accessCode: string, redirectURI: string}): LoginOpenId_planner => {
        return new LoginOpenId_planner(x.accessCode, x.redirectURI);
          }
	public static readonly returnSchema = z.lazy(() => logonResponseSchema);
	public resultFromJSON(json: WebResponseResult<LogonResponse>): LogonResponse {
		return validate(LoginOpenId_planner.returnSchema, json) as unknown as LogonResponse;
	}
}

/**
	Logon with windows active directory Returns token a token to be used in future Authorization
	Responsible: AW, Updated: 20220811
*/
export class LoginBasic extends WebRequest<LogonResponse> {
	public readonly webService = "login";
	public readonly method = "LoginBasic";
	public readonly noUserValidation = true;
	public readonly noAuditAction = false;

	constructor(
		public username: string,
		public password: string,
		public application: ApplicationEnum,
	) {
		super();
	}

	public static readonly create = (x: {username: string, password: string, application: ApplicationEnum}): LoginBasic => {
        return new LoginBasic(x.username, x.password, x.application);
          }
	public static readonly returnSchema = z.lazy(() => logonResponseSchema);
	public resultFromJSON(json: WebResponseResult<LogonResponse>): LogonResponse {
		return validate(LoginBasic.returnSchema, json) as unknown as LogonResponse;
	}
}

/**
	Register a public key for biometric authentication on a device
	Responsible: AGRU, Updated: 20240619
*/
export class RegisterBiometricAuth extends WebRequest<boolean> {
	public readonly webService = "login";
	public readonly method = "RegisterBiometricAuth";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public deviceId: string,
		public publicKey: string,
	) {
		super();
	}

	public static readonly create = (x: {deviceId: string, publicKey: string}): RegisterBiometricAuth => {
        return new RegisterBiometricAuth(x.deviceId, x.publicKey);
          }
	public static readonly returnSchema = z.boolean();
	public resultFromJSON(json: WebResponseResult<boolean>): boolean {
		return validate(RegisterBiometricAuth.returnSchema, json) as unknown as boolean;
	}
}

/**
	Generate a one-time token for biometric authentication
	Responsible: AGRU, Updated: 20240619
*/
export class GetTokenForBiometricAuth extends WebRequest<string> {
	public readonly webService = "login";
	public readonly method = "GetTokenForBiometricAuth";
	public readonly noUserValidation = true;
	public readonly noAuditAction = false;

	constructor(
		public deviceId: string,
		public application: ApplicationEnum,
		public lastJwt: string,
	) {
		super();
	}

	public static readonly create = (x: {deviceId: string, application: ApplicationEnum, lastJwt: string}): GetTokenForBiometricAuth => {
        return new GetTokenForBiometricAuth(x.deviceId, x.application, x.lastJwt);
          }
	public static readonly returnSchema = z.string();
	public resultFromJSON(json: WebResponseResult<string>): string {
		return validate(GetTokenForBiometricAuth.returnSchema, json) as unknown as string;
	}
}

/**
	Logon using biometric authentication Returns a token to be used in future Authorization
	Responsible: AGRU, Updated: 20240619
*/
export class LogonBiometricAuth extends WebRequest<LogonResponse> {
	public readonly webService = "login";
	public readonly method = "LogonBiometricAuth";
	public readonly noUserValidation = true;
	public readonly noAuditAction = false;

	constructor(
		public deviceId: string,
		public signature: string,
		public application: ApplicationEnum,
		public lastJwt: string,
	) {
		super();
	}

	public static readonly create = (x: {deviceId: string, signature: string, application: ApplicationEnum, lastJwt: string}): LogonBiometricAuth => {
        return new LogonBiometricAuth(x.deviceId, x.signature, x.application, x.lastJwt);
          }
	public static readonly returnSchema = z.lazy(() => logonResponseSchema);
	public resultFromJSON(json: WebResponseResult<LogonResponse>): LogonResponse {
		return validate(LogonBiometricAuth.returnSchema, json) as unknown as LogonResponse;
	}
}

/**
	Refresh the JWT. Fails if the JWT is expired. If the JWT is close to expiry, a refreshed JWT is returned in the PdcAuthorization header.
	Responsible: AGRU, Updated: 20241202
*/
export class RefreshJwt extends WebRequest<boolean> {
	public readonly webService = "login";
	public readonly method = "RefreshJwt";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
	) {
		super();
	}

	public static readonly create = (x: {}): RefreshJwt => {
        return new RefreshJwt();
          }
	public static readonly returnSchema = z.boolean();
	public resultFromJSON(json: WebResponseResult<boolean>): boolean {
		return validate(RefreshJwt.returnSchema, json) as unknown as boolean;
	}
}

/**
	Impersonate an employee. At least one of the optional parameters must be filled. If the method succeeds, it will return a JWT for the impersonated empuser, and the session of the calling user will be updated to contain the impersonated empusers id.
	Responsible: AGRU, Updated: 20250915
*/
export class ImpersonateEmpuser extends WebRequest<ImpersonateResponse> {
	public readonly webService = "login";
	public readonly method = "ImpersonateEmpuser";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public Username: string | null = null,
		public Person: WsRefPerson | null = null,
	) {
		super();
	}

	public static readonly create = (x: {Username: string | null, Person: WsRefPerson | null}): ImpersonateEmpuser => {
        return new ImpersonateEmpuser(x.Username, x.Person);
          }
	public static readonly returnSchema = z.lazy(() => impersonateResponseSchema);
	public resultFromJSON(json: WebResponseResult<ImpersonateResponse>): ImpersonateResponse {
		return validate(ImpersonateEmpuser.returnSchema, json) as unknown as ImpersonateResponse;
	}
}

export const LoginAI = { key: 'login_Login' as const,
          webService: 'login' as const,
           method: 'Login' as const,
           description: "Login for user with given username and password plus a deviceid used to send push messages back to that user Returns a token to be used in future Authorization headers if login succeeds",
           inputJsonSchema: z.object({ username: z.string(), password: z.string(), deviceid: z.string(), application: ApplicationJsonSchema}),
           inputSchema: z.object({ username: z.string(), password: z.string(), deviceid: z.string(), application: ApplicationSchema}),
          outputJsonSchema: z.lazy(() => logonResponseJsonSchema),
          outputSchema: z.lazy(() => logonResponseSchema),
          requestClass: Login
          }
export const LogoutAI = { key: 'login_Logout' as const,
          webService: 'login' as const,
           method: 'Logout' as const,
           description: "Logout the current user (specified in the JWT) and end the pdcsession such that the JWT cannot be renewed",
           inputJsonSchema: z.object({ }),
           inputSchema: z.object({ }),
          outputJsonSchema: z.boolean(),
          outputSchema: z.boolean(),
          requestClass: Logout
          }
export const Login_02AI = { key: 'login_Login_02' as const,
          webService: 'login' as const,
           method: 'Login_02' as const,
           description: "StaffUser logon with frontend hashed password The field LogonResponse.staffUserType always returns the usertype",
           inputJsonSchema: z.object({ username: z.string(), passwordHash: z.string(), application: ApplicationJsonSchema}),
           inputSchema: z.object({ username: z.string(), passwordHash: z.string(), application: ApplicationSchema}),
          outputJsonSchema: z.lazy(() => logonResponseJsonSchema),
          outputSchema: z.lazy(() => logonResponseSchema),
          requestClass: Login_02
          }
export const MakeFrontendHashedPasswordAI = { key: 'login_MakeFrontendHashedPassword' as const,
          webService: 'login' as const,
           method: 'MakeFrontendHashedPassword' as const,
           description: "Make a frontend hashed password",
           inputJsonSchema: z.object({ username: z.string(), password: z.string()}),
           inputSchema: z.object({ username: z.string(), password: z.string()}),
          outputJsonSchema: z.string(),
          outputSchema: z.string(),
          requestClass: MakeFrontendHashedPassword
          }
export const LoginOpenId_employeeAI = { key: 'login_LoginOpenId_employee' as const,
          webService: 'login' as const,
           method: 'LoginOpenId_employee' as const,
           description: "Logon with OpenId Returns token from openid",
           inputJsonSchema: z.object({ accessCode: z.string(), redirectURI: z.string()}),
           inputSchema: z.object({ accessCode: z.string(), redirectURI: z.string()}),
          outputJsonSchema: z.lazy(() => logonResponseJsonSchema),
          outputSchema: z.lazy(() => logonResponseSchema),
          requestClass: LoginOpenId_employee
          }
export const LoginOpenId_plannerAI = { key: 'login_LoginOpenId_planner' as const,
          webService: 'login' as const,
           method: 'LoginOpenId_planner' as const,
           description: "Logon with OpenId Returns token from openid",
           inputJsonSchema: z.object({ accessCode: z.string(), redirectURI: z.string()}),
           inputSchema: z.object({ accessCode: z.string(), redirectURI: z.string()}),
          outputJsonSchema: z.lazy(() => logonResponseJsonSchema),
          outputSchema: z.lazy(() => logonResponseSchema),
          requestClass: LoginOpenId_planner
          }
export const LoginBasicAI = { key: 'login_LoginBasic' as const,
          webService: 'login' as const,
           method: 'LoginBasic' as const,
           description: "Logon with windows active directory Returns token a token to be used in future Authorization",
           inputJsonSchema: z.object({ username: z.string(), password: z.string(), application: ApplicationJsonSchema}),
           inputSchema: z.object({ username: z.string(), password: z.string(), application: ApplicationSchema}),
          outputJsonSchema: z.lazy(() => logonResponseJsonSchema),
          outputSchema: z.lazy(() => logonResponseSchema),
          requestClass: LoginBasic
          }
export const RegisterBiometricAuthAI = { key: 'login_RegisterBiometricAuth' as const,
          webService: 'login' as const,
           method: 'RegisterBiometricAuth' as const,
           description: "Register a public key for biometric authentication on a device",
           inputJsonSchema: z.object({ deviceId: z.string(), publicKey: z.string()}),
           inputSchema: z.object({ deviceId: z.string(), publicKey: z.string()}),
          outputJsonSchema: z.boolean(),
          outputSchema: z.boolean(),
          requestClass: RegisterBiometricAuth
          }
export const GetTokenForBiometricAuthAI = { key: 'login_GetTokenForBiometricAuth' as const,
          webService: 'login' as const,
           method: 'GetTokenForBiometricAuth' as const,
           description: "Generate a one-time token for biometric authentication",
           inputJsonSchema: z.object({ deviceId: z.string(), application: ApplicationJsonSchema, lastJwt: z.string()}),
           inputSchema: z.object({ deviceId: z.string(), application: ApplicationSchema, lastJwt: z.string()}),
          outputJsonSchema: z.string(),
          outputSchema: z.string(),
          requestClass: GetTokenForBiometricAuth
          }
export const LogonBiometricAuthAI = { key: 'login_LogonBiometricAuth' as const,
          webService: 'login' as const,
           method: 'LogonBiometricAuth' as const,
           description: "Logon using biometric authentication Returns a token to be used in future Authorization",
           inputJsonSchema: z.object({ deviceId: z.string(), signature: z.string(), application: ApplicationJsonSchema, lastJwt: z.string()}),
           inputSchema: z.object({ deviceId: z.string(), signature: z.string(), application: ApplicationSchema, lastJwt: z.string()}),
          outputJsonSchema: z.lazy(() => logonResponseJsonSchema),
          outputSchema: z.lazy(() => logonResponseSchema),
          requestClass: LogonBiometricAuth
          }
export const RefreshJwtAI = { key: 'login_RefreshJwt' as const,
          webService: 'login' as const,
           method: 'RefreshJwt' as const,
           description: "Refresh the JWT. Fails if the JWT is expired. If the JWT is close to expiry, a refreshed JWT is returned in the PdcAuthorization header.",
           inputJsonSchema: z.object({ }),
           inputSchema: z.object({ }),
          outputJsonSchema: z.boolean(),
          outputSchema: z.boolean(),
          requestClass: RefreshJwt
          }
export const ImpersonateEmpuserAI = { key: 'login_ImpersonateEmpuser' as const,
          webService: 'login' as const,
           method: 'ImpersonateEmpuser' as const,
           description: "Impersonate an employee. At least one of the optional parameters must be filled. If the method succeeds, it will return a JWT for the impersonated empuser, and the session of the calling user will be updated to contain the impersonated empusers id.",
           inputJsonSchema: z.object({ Username: z.string().optional().nullable().default(null), Person: z.lazy(() => wsRefPersonJsonSchema).optional().nullable().default(null)}),
           inputSchema: z.object({ Username: z.string().optional().nullable().default(null), Person: z.lazy(() => wsRefPersonSchema).optional().nullable().default(null)}),
          outputJsonSchema: z.lazy(() => impersonateResponseJsonSchema),
          outputSchema: z.lazy(() => impersonateResponseSchema),
          requestClass: ImpersonateEmpuser
          }
export const endpoints = [LoginAI, LogoutAI, Login_02AI, MakeFrontendHashedPasswordAI, LoginOpenId_employeeAI, LoginOpenId_plannerAI, LoginBasicAI, RegisterBiometricAuthAI, GetTokenForBiometricAuthAI, LogonBiometricAuthAI, RefreshJwtAI, ImpersonateEmpuserAI] as const;
export type Endpoint = (typeof endpoints)[number];
